import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import range from 'lodash/range';
import get from 'lodash/get';
import reverse from 'lodash/reverse';
import Select from '../../../core/form/Select';
import ColumnSeparator from '../../../core/layout/ColumnSeparator';

const MonthRankingFilter = (props) => (
  <>
    <Select
      value={get(props.values, 'year', '')}
      onChange={(year) => {
        props.onChange('year', year);
        props.onSearch();
      }}
      options={reverse(range(2020, moment().year() + 1))
        .map((year) => moment(year, 'YYYY'))
        .map((momentYear) => ({
          label: momentYear.format('YYYY'),
          value: momentYear.format('YYYY'),
        }))}
      formItemStyle={{
        width: 90,
      }}
    />
    <ColumnSeparator size="xxs" />
    <Select
      value={get(props.values, 'month', '')}
      onChange={(month) => {
        props.onChange('month', month);
        props.onSearch();
      }}
      options={range(1, 13)
        .map((month) => moment(month, 'MM'))
        .map((momentMonth) => ({
          label: momentMonth.format('MMMM'),
          value: momentMonth.format('MM'),
        }))}
      formItemStyle={{
        width: 120,
      }}
    />
  </>
);

MonthRankingFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default MonthRankingFilter;
